module.exports = __webpack_public_path__ + "static/about02-1877556aedb7a77e48c1e432332967c8.jpg";